import type { AppModule } from "../types";

export const dashboardModule: AppModule = {
  name: "dashboard",
  routes: {
    shell: [
      {
        path: "/dashboard",
        handle: { title: "Dashboard" },
        lazy: () => import("./pages/DashboardPage").then((m) => ({ Component: m.DashboardPage })),
      },
    ],
  },
};
